import React from "react";
import TransactionsHeader from "./transactionsHeader/transactionsHeader";
import TransactionsList from "./transactionsList/transactionsList";
import PropTypes from "prop-types";



const Transactions = (props) => {
  const {ddTransactionsList = [], pickedTransactionDd, transactionHeaderDdOnChange ,
    transactions , title , rightTitle = '', onRightTitleClick = ()=>'' , statementsUrl = [],
    isPickedTransaction} = props;

  Transactions.propTypes = {
    ddTransactionsList: PropTypes.array,
    pickedTransactionDd: PropTypes.number,
    transactionHeaderDdOnChange: PropTypes.func,
    transactions: PropTypes.array,
    title: PropTypes.string,
    rightTitle: PropTypes.string,
    onRightTitleClick: PropTypes.func,
    statementsUrl: PropTypes.array,
    isPickedTransaction: PropTypes.bool,
  };
 /*
 *  ddTransactionsList - list
 *  pickedTransactionDd - the current dd option
 *  transactionHeaderDdOnChange - callback when click dd
 *  transactions - all the data for the tbale
 *  title - component title
 *  rightTitle - small title from the right
 *
 * */
    return (
     <div>
       <TransactionsHeader optionalDdData={ddTransactionsList}
                           rightTitle={rightTitle}
                           onRightTitleClick = {onRightTitleClick}
                           pickedTransactionDd={pickedTransactionDd}
                           ddOnChange={transactionHeaderDdOnChange}
                           placeHolderDd={'select a statement'}
                           statementsUrl={statementsUrl}
                           title={title}
                           isPickedTransaction={isPickedTransaction}/>
       <TransactionsList title={title} transactions={transactions}/>
     </div>
    );
  };


export default Transactions;



// WEBPACK FOOTER //
// ./src/card/transaction/transactions.js